// extracted by mini-css-extract-plugin
export default {"element":"InfoBoxAlt-module--element--ed8b2","container":"InfoBoxAlt-module--container--46d62","list":"InfoBoxAlt-module--list--6775f"};